import { GuidStrValue, PatientResultsFilterFormValue, PatientTrackResultFilter } from 'webcommon/shared';
import { ListFilterType } from './ListFilterType';
import { MedicationFilterFormValue } from '../fc-filter/medication-filter/models/MedicationFilterFormControls';

export enum FilterChangedStatus {
  FilterSelected,
  DynamicFilter,
}

export type FilterTypeDataMap = {
  [ListFilterType.ControlMedicationHxFilter]: MedicationFilterFormValue;
  [ListFilterType.ControlResultsPatientFilter]: PatientResultsFilterFormValue;
  // [ListFilterType.ControlMessageCenterFilter]: MessageCenterFilterValue;
  [ListFilterType.ControlResultTrackingFilter]: PatientTrackResultFilter;
};

export interface FilterData<K extends keyof FilterTypeDataMap = keyof FilterTypeDataMap> {
  filterType: K;
  filterId: GuidStrValue | null;
  data: FilterTypeDataMap[K] | null;
}

export interface FilterChangedResult {
  filterChangedStatus: FilterChangedStatus;
  filterData: FilterData;
}
